import axios from "axios"

// Get backend URL from environment variables or use default
const baseURL = import.meta.env.VITE_API_URL || "https://api.kupimotor.rs/api"

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
})

// Request interceptor - add token to requests
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("auth_token")
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor - handle responses and errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response.data
  },
  (error) => {
    // Only auto-redirect on 401 if we're not already on login page
    // This prevents redirect loops during login attempts
    if (error.response?.status === 401 && !window.location.pathname.includes("/login")) {
      localStorage.removeItem("auth_token")
      localStorage.removeItem("auth_user")
      window.location.href = "/login"
    }

    // Preserve the error structure for proper error handling
    return Promise.reject(error)
  }
)

export default axiosInstance
